module.exports = __webpack_public_path__ + "static/media/eggs.a0aa78e1.jpg";